<div class="complete-profile-confirmation-container" id="complete-profile-confirmation-container">
  <div id="confirmation-container">
    <div class="row no-gutters">
      <div class="col-md-3"></div>

      <div class="col-md-6" id="profile-confirmation-container">
        <div id="confirmation-header">
          <div id="complete-profile-confirmation-check" class="check">
            <div class="image" id="img">
              <img src="assets/images/check-large.png" alt="Check">
            </div>
          </div>
          <div id="complete-profile-confirmation-desc">
            <h1 style="display:none;">Fix for sonar issues</h1>
            <strong>
              <h2 class="profile-heading">{{cfetLabels.cfet_complete_profile_confirmation.profile_confirmation_heading}}
              </h2>
              <p class="profile-desc">{{cfetLabels.cfet_complete_profile_confirmation.profile_confirmation_desc}}</p>
            </strong>
            <p class="profile-header-content">
              {{cfetLabels.cfet_complete_profile_confirmation.profile_confirmation_desc1}}</p>
          </div>

          <div class="col-md-12" id="profile-footer-column">
            <button type="button" id="btn-shopNow" (click)="shopNow($event)" (keyup)="shopNow($event)" tabindex="0">
              <em aria-label=""></em>
              {{cfetButtonLabels.button_labels.shopNow}}</button>
          </div>
        </div>

      </div>

      <div class="col-md-3"></div>
    </div>
  </div>

  <div class="profile-confirmation-footer row no-gutters">
    <div class="col-md-3"></div>
    <div class="col-md-6" id="profile-footer-content">
      <div class="row" id="profile-content">
        <div class="col-1"></div>
        <div class="col-5">
          <div id="responder-plans">
            <a href="{{cfetNavLinks.header_links.header_plans_link}}" target="_blank" rel="noopener">
              <img src="assets/images/responder_plans.png" alt="Responder Plans Checklist" id="responder-image">
            </a>
            <p class="responder-desc">{{cfetLabels.cfet_complete_profile_confirmation.responder_plans}}</p>
          </div>
        </div>


        <div class="col-5">
          <div id="feature-devices">
            <a href="{{cfetNavLinks.header_links.header_devices_link}}" target="_blank" rel="noopener">
              <img src="assets/images/hand_device.png" alt="Featured Devices" id="featured-image">
            </a>
            <p class="featured-desc">{{cfetLabels.cfet_complete_profile_confirmation.featured_devices}}</p>
          </div>
        </div>
        <div class="col-1"></div>


      </div>


    </div>

    <div class="col-md-3"></div>

  </div>

</div>